export const SET_OUT_OF_SERVICE = 'set_out_of_service'

export const RESET_REDUX = 'reset_redux'

export const SET_USER = 'set_user'

export const SET_SELECTED_ROOM = 'set_selected_room'

export const SET_CURRENT_ROOM = 'set_current_room'

export const SET_GUEST = 'set_guest'

export const CLEAN_ROOM_SELECTION = 'clean_room_selection'

export const CLEAN_CURRENT_ROOM_SELECTION = 'clean_current_room_selection'

export const CLEAN_GUEST_SELECTION = 'clean_guest_selection'

export const SET_CUSTOMER_INFO = 'set_customer_info'

export const SET_STAFF_INFO = 'set_staff_info'

export const SET_PAYMENT_INFO = 'set_payment_info'

export const CLEAN_PAYMENT_INFO = 'clean_payment_info'

export const SET_PICKED_DATE = 'set_picked_date'